export const CRUD_CREATE = 'EPIC/CRUD_CREATE';
export const CRUD_CREATE_FAILURE = 'EPIC/CRUD_CREATE_FAILURE';
export const CRUD_CREATE_SUCCESS = 'APIC/CRUD_CREATE_SUCCESS';
